module.exports = __webpack_public_path__ + "static/img/xcx.0b77580.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xcx.jpg
// module id = Mv/4
// module chunks = 8